export default __webpack_public_path__ + "static/avatar-web-7e2db684627478b4c7c237a6847305ce.jpg";